/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import ReactGA from 'react-ga';

ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS ?? '');

export { ReactGA };
